<template>
  <div :class="{'container-setting': !isMenuMiniSize, 'container-setting-thin-menu': isMenuMiniSize}">
    <div class="setting-contents">
      <BillingSetting   v-if="$route.path.indexOf('/setting/billing') >= 0"/>
      <PersonalSetting  v-if="$route.path.indexOf('/setting/personal') >= 0" :PCTRLLOG="CTRLLOG"/>
      <CommonSetting    v-if="$route.path.indexOf('/setting/common') >= 0" :PCTRLLOG="CTRLLOG"/>
      <CompanySetting   v-if="$route.path.indexOf('/setting/company') >= 0" :PCTRLLOG="CTRLLOG"/>
      <UserAdminSetting v-if="$route.path.indexOf('/setting/user_list') >= 0" :PCTRLLOG="CTRLLOG"/>
      <NotifySetting    v-if="$route.path.indexOf('/setting/other_api') >= 0"/>
      <AppIconSetting   v-if="$route.path.indexOf('/setting/app_icon') >= 0" :PCTRLLOG="CTRLLOG"/>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapState } from 'vuex'
import getParam from '@/functions/getParam'
import BillingSetting from '@/views/DashBoard/Setting/Billing/BillingSetting'
import PersonalSetting from '@/views/DashBoard/Setting/PersonalSetting'
import CompanySetting from '@/views/DashBoard/Setting/CompanySetting'
import NotifySetting from '@/views/DashBoard/Setting/NotifySetting'
import UserAdminSetting from '@/views/DashBoard/Setting/UserAdminSetting'
import CommonSetting from '@/views/DashBoard/Setting/CommonSetting'
import AppIconSetting from '@/views/DashBoard/Setting/AppIconSetting'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'Setting',
  componentName: 'Setting',
  components: {
    BillingSetting,
    CommonSetting,
    PersonalSetting,
    CompanySetting,
    NotifySetting,
    UserAdminSetting,
    AppIconSetting
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      COMPONENT_NAME: 'Setting',
      uploadedImage: '',
      filename: 'no file',
      repassword: '',
      inputs: {
        companyname: '',
        username: '',
        email: '',
        password: ''
      },
      on: true,
      sec: '10'
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  created () {
    this.$store.dispatch('auth/getCompanyHomePage', null)
    this.$store.dispatch('auth/getSlackStatus')
    this.$store.dispatch('auth/getCWStatus')
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
    console.debug('*** Start *** created')
    var code = getParam('code')
    var status = getParam('state')
    console.log('========= getQuery Parameter ========= :' + code + ' : ' + status)
    var vm = this
    setTimeout(function () {
      if (code !== null && status == '') {
        vm.$store.dispatch('auth/slackLink', {code: code, sec: vm.sec, on: vm.on})
      } else if (code !== null && status != null) {
        vm.$store.dispatch('auth/CWLink', {code: code, sec: vm.sec, on: vm.on})
      }
    }, 2000)
    console.debug('*** End *** created')
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
}
</script>

<style lang="scss" scoped>
.container-setting {
  padding: 0px !important;
  margin: 0px !important;
  height: 100vh;
  width: calc(100vw - 204px);
  background-color: #ffffff;
  overflow: scroll;
}
.container-setting-thin-menu {
  padding: 0px !important;
  margin: 0px !important;
  height: 100vh;
  width: calc(100vw - 55px);
  background-color: #ffffff;
  overflow: scroll;
}
.container-setting::-webkit-scrollbar {
    width:  0px;
    height: 0px;
    visibility: hidden;
}
.clearfix:after {
  display:block;
  clear:both;
  height:0px;
  visibility:hidden;
}
.menu {
  margin: 24px auto;
  display: flex;
  justify-content: space-between;
  width: 80%;
  a {
    color: #363636;
  }
  a:hover {
    color: #AA0066;
  }
}
.click-menu {
  color: #AA0066 !important;
  border-bottom: 1px solid #AA0066;
}
.setting-contents {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/Setting.vue